import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]
  static values = { path: String, type: String }

  connect() {
    this.boundCloseOnOutsideClick = this.closeOnOutsideClick.bind(this)
    this.boundCloseOnEscape = this.closeOnEscape.bind(this)
  }

  disconnect() {
    if (this.boundCloseOnOutsideClick) {
      document.removeEventListener("click", this.boundCloseOnOutsideClick)
    }
    if (this.boundCloseOnEscape) {
      document.removeEventListener("keydown", this.boundCloseOnEscape)
    }
  }

  showModal() {
    if (!this.hasModalTarget) return
    
    this.modalTarget.classList.remove("hidden")
    this.modalTarget.classList.add("flex")
    
    // Add event listeners for clicking outside modal and ESC key
    setTimeout(() => {
      document.addEventListener("click", this.boundCloseOnOutsideClick)
      document.addEventListener("keydown", this.boundCloseOnEscape)
    }, 100)
  }

  hideModal() {
    if (this.hasModalTarget) {
      this.modalTarget.classList.add("hidden")
      this.modalTarget.classList.remove("flex")
    }
    document.removeEventListener("click", this.boundCloseOnOutsideClick)
    document.removeEventListener("keydown", this.boundCloseOnEscape)
  }

  closeOnOutsideClick(event) {
    if (!this.hasModalTarget) return
    
    const modalContent = this.modalTarget.querySelector("[data-modal-content]")
    if (modalContent && !modalContent.contains(event.target)) {
      this.hideModal()
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape" || event.keyCode === 27) {
      this.hideModal()
    }
  }

  confirmDelete(event) {
    event.preventDefault()
    
    // Hide the modal immediately
    this.hideModal()
    
    // Create a form and submit it to delete the item
    const form = document.createElement('form')
    form.method = 'POST'
    form.action = this.pathValue

    // Add hidden method field for DELETE
    const methodInput = document.createElement('input')
    methodInput.type = 'hidden'
    methodInput.name = '_method'
    methodInput.value = 'DELETE'
    form.appendChild(methodInput)

    // Add CSRF token
    const csrfToken = document.querySelector('[name="csrf-token"]')?.content ||
                     document.querySelector('meta[name="csrf-token"]')?.content
    if (csrfToken) {
      const csrfInput = document.createElement('input')
      csrfInput.type = 'hidden'
      csrfInput.name = 'authenticity_token'
      csrfInput.value = csrfToken
      form.appendChild(csrfInput)
    }

    // Submit the form
    document.body.appendChild(form)
    form.submit()
  }
}